import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import TextEditorContainer from '../../../containers/TextEditorContainer';
import LocaleText from '../../LocaleText';

class TextEditorPopup extends React.Component {
    render() {
        const classes = ['popup'];
        const { onConfirm, onCancel, onClose, isVisible } = this.props;
        if (!isVisible) {
            return null;
        }
        if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
            classes.push('is-iphone');
        }

        return (
            <div className={classes.join(' ')}>
                <div className="popup__box">
                    <header className="popup__header">
                        <h3 className="popup__title">
                            <LocaleText textKey="popup.texteditor.title" />
                        </h3>
                        <div className="popup__close" onClick={onClose}>
                            <Isvg src="/svg/cancel.svg" />
                        </div>
                    </header>
                    <div className="popup__body">
                        <TextEditorContainer showColorSelect={this.props.showColorSelect} />
                    </div>
                    <div className="buttons">
                        <button onClick={onCancel}>
                            <LocaleText textKey="popup.cancel" />
                        </button>
                        <button className="is-primary" onClick={onConfirm}>
                            <LocaleText textKey="popup.confirm" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

TextEditorPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    showColorSelect: PropTypes.bool,
};

TextEditorPopup.defaultProps = {
    showColorSelect: true,
};

export default TextEditorPopup;
